import React from 'react'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import PropTypes from 'prop-types'
import InViewBanner from './InViewBanner'
import CarouselBanner from './CarouselBanner'

const CitrusBanners = ({ banners, searchTerm, categoryName, placement, clpPosition }) => {
  if (!banners || banners.length === 0) {
    return null
  }

  const top3Banners = banners.filter(banner => banner.position <= 3)
  const bottom3Banners = banners.filter(banner => banner.position > 3)

  return (
    <ErrorBoundary>
      <div data-test='citrus-bannersx'>
        {placement !== 'category-landing-argos' &&
          banners.map(banner => (
            <InViewBanner
              key={banner.position}
              searchTerm={searchTerm}
              categoryName={categoryName}
              placement={placement}
              banner={banner}
            />
          ))}
        {placement === 'category-landing-argos' && clpPosition === 'top' && top3Banners.length > 0 && (
          <CarouselBanner placement={placement} categoryName={categoryName} data={top3Banners} />
        )}
        {placement === 'category-landing-argos' && clpPosition === 'bottom' && bottom3Banners.length > 0 && (
          <CarouselBanner placement={placement} categoryName={categoryName} data={bottom3Banners} />
        )}
      </div>
    </ErrorBoundary>
  )
}

CitrusBanners.propTypes = {
  searchTerm: PropTypes.string,
  categoryName: PropTypes.string,
  placement: PropTypes.string,
  clpPosition: PropTypes.string,
  banners: PropTypes.array
}

CitrusBanners.defaultProps = {
  searchTerm: null,
  categoryName: '',
  placement: '',
  clpPosition: 'top',
  banners: []
}

export default CitrusBanners
